import styled from 'styled-components';

export const HideIconNumber = styled.div`
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
